import { FunctionComponent } from "react"
import { TimelineTemplateProps } from "../../interfaces"
import {
	TimelineDoubleChartTemplate,
	TimelineGrowthChartTemplate,
} from "./index"

export type TemplateTimelineType =
	| "double"
	| "growth"
	| "penetration_double"
	| "penetration_growth"
type TimelineTemplate = FunctionComponent<TimelineTemplateProps> | null

const TimelineTemplateManagerConfig: Record<
	TemplateTimelineType,
	TimelineTemplate
> = {
	double: TimelineDoubleChartTemplate,
	growth: TimelineGrowthChartTemplate,
	penetration_double: TimelineDoubleChartTemplate,
	penetration_growth: TimelineGrowthChartTemplate,
}

export default TimelineTemplateManagerConfig
